import React, { useState, useEffect, useCallback } from 'react';
import {
  IconButton, Grid, Typography, Button
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { debounce } from 'lodash';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import DeleteDialog from '../../components/DeleteDialog';
import TableData from '../../components/TableData';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import useStyles from './styles';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';
import {
  cnpjMask, toCurrency
} from '../../utils/mask';

function getDescricao(desc) {
  if (!desc) {
    return 'Não informada';
  }
  return desc.length < 30
    ? desc : `${desc.slice(0, 30)}...`;
}

export default function Produtos() {
  const history = useHistory();
  const classes = useStyles();
  const [produtos, setprodutos] = useState([]);
  const [openDelete, setOpenDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [error, setError] = useState(null);
  const layoutDispatch = useLayoutDispatch();

  useEffect(() => {
    produtosRequest();
  }, [page, search]);

  async function produtosRequest() {
    toggleLoading(layoutDispatch);
    setError(null);
    try {
      const { data } = await api.get(`/produto?pagina=${page}&nome=${search}`);
      setTotal(data.totalPaginas);
      setprodutos(data.dados.map((item) => ({
        ...item,
        descricao: getDescricao(item.descricao),
        valor: toCurrency(item.valor, true)
      })));
      if (page > data.totalPaginas) {
        setPage(1);
      }
    } catch (error) {
      setError(getError(error));
    }
    toggleLoading(layoutDispatch);
  }

  const handleSearch = (query) => {
    setSearch(query);
  };

  const onSearch = useCallback(
    debounce(handleSearch, 500),
    []
  );

  function handlePage(newPage) {
    if (newPage !== page) {
      setPage(newPage);
    }
  }

  function handleDeleteConfirmation(index) {
    setOpenDelete(index.toString());
  }

  function handleCancelDelete() {
    setOpenDelete(null);
  }

  function handleReload() {
    produtosRequest();
  }

  async function handleDelete() {
    const produto = produtos[openDelete];
    try {
      await api.delete(`/produto/${produto.id_produto}`);
      Notification({
        type: 'shipped',
        message: 'Produto excluído com sucesso!',
        variant: 'contained',
        color: 'success',
      });
      produtosRequest();
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    setOpenDelete(null);
  }

  function handleEdit(index) {
    const produto = produtos[index];
    history.push(`/app/produtos/cadastro/${produto.id_produto}`);
  }

  return (
    <>
      <DeleteDialog
        open={!!openDelete}
        handleClose={handleCancelDelete}
        handleConfirm={handleDelete}
        message="Tem certeza que deseja excluir o produto?"
      />
      <PageTitle
        title="Produtos"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/produtos/cadastro')}
          >
            <AddIcon />
          </IconButton>
        )}
      />
      {error && (
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}

          >
            <Widget
              disableWidgetMenu
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Ocorreu um erro ao tentar listar os produtos
              </Typography>
              <Typography
                variant="p"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Mensagem de erro:
                {' '}
                {error}
              </Typography>
              <br />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 50
                }}
                onClick={handleReload}
              >
                Tentar novamente
              </Button>
            </Widget>
          </Grid>
        </Grid>
      )}
      {!error && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableData
              title="Produtos cadastrados"
              columns={[{
                name: 'nome',
                label: 'Nome',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                name: 'descricao',
                label: 'Descrição',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'valor',
                label: 'Valor',
                options: {
                  filter: true,
                  sort: false,
                }
              }]}
              data={produtos}
              search={onSearch}
              page={page}
              total={total}
              onSetPage={handlePage}
              onCloseSearch={setSearch}
              onEdit={handleEdit}
              onDelete={handleDeleteConfirmation}
              showEdit
              showDelete
              showSearch
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
